@if (pageReady) {
  <main class="gs-page">
    <div class="page-container">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="gs-content-container delete-account-container">
        <div class="delete-account-section delete-account-lead">
          <h2 class="h2-lg">{{ pageLabels.deleteAccountSubHeaderText }}</h2>
          <p>{{ pageLabels.deleteAccountConfirmationText }}</p>
        </div>
        <mat-divider style="width: 100%"></mat-divider>
        <div class="delete-account-section delete-cta-container">
          <div class="username-title">{{ pageLabels.deleteAccountUserNameText }}</div>
          <div class="username">{{ userProfile?.UserName! }}</div>
          <p>{{ pageLabels.deleteAccountRegisterAgainText }}</p>
        </div>
        <div class="cta-container">
          <a
            [routerLink]="pageLabels.deleteAccountManageAccountLink.value.data.url"
            class="keep-link"
            [attr.aria-label]="pageLabels.deleteAccountKeepAccountLinkAriaLabel"
            >{{ pageLabels.deleteAccountKeepAcountLinkText }}</a
          >
          <button
            role="link"
            class="gs-form-button-primary"
            mat-flat-button
            color="primary"
            [attr.aria-label]="pageLabels.deleteAccountDeleteButtonAriaLabel"
            (click)="deleteUserName()"
          >
            {{ pageLabels.deleteAccountDeleteButtonText }}
          </button>
        </div>
      </div>
    </div>
  </main>
}
